module.exports = __webpack_public_path__ + "static/media/attebery.67bb7cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/assets/attebery.png
// module id = 444
// module chunks = 0